// extracted by mini-css-extract-plugin
module.exports = {"heading":"member-operations__MemberTaskHistoryLog__heading","loadingBlock":"member-operations__MemberTaskHistoryLog__loadingBlock"};